import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PubSub from 'pubsub-js';

import Modal from 'js/components/core/Modal';
import LoginSignupDialog from 'js/components/common/LoginSignupDialog';

import Title from './Title';
import LockIcon from './LockIcon';
import Container from './Container';

@inject('page')
@observer
export default class SignupSignIn extends Component {
  closeModal = () => window.history.back();

  componentDidMount() {
    PubSub.publishSync('canReboot', false);
  }
  componentWillUnmount() {
    PubSub.publishSync('canReboot', true);
  }

  render() {
    return (
      <Modal showModal onCancel={this.closeModal} withCloseButton>
        <Container>
          <LockIcon />
          <Title>Create an account</Title>
          <LoginSignupDialog
            facebookButtonLabel="Sign up with Facebook"
            after={this.props.page.nextStep}
            showForm="signup"
            page={this.props.page}
          />
        </Container>
      </Modal>
    );
  }
}
